const SalirIconDrop = ({ className, stroke, color }) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill={color ? color: "var(--color-black)"}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2728:10140)">
        <path
          d="M7.2 17H2.5V2.5H7.3C8 2.5 8.5 1.9 8.5 1.3C8.5 0.7 7.9 0 7.2 0H1.2C0.6 0 0 0.6 0 1.2V18.2C0 18.9 0.6 19.4 1.2 19.4H7.2C7.9 19.4 8.4 18.8 8.4 18.2C8.4 17.6 7.9 17 7.2 17Z"
          fill={color ? color: "var(--color-black)"}
        />
        <path
          d="M17.4 9.90005C17.4 9.80005 17.3 9.70005 17.3 9.70005L17.2 9.60005L13.7 4.60005C13.4 4.00005 12.6 3.80005 12 4.20005C11.4 4.60005 11.3 5.40005 11.7 5.90005L13.8 8.90005H5.2C4.6 9.00005 4 9.60005 4 10.2C4 10.8 4.6 11.4 5.2 11.4H14L11.7 15C11.3 15.6 11.5 16.4 12.1 16.7C12.3 16.8 12.5 16.9 12.8 16.9C13.2 16.9 13.6 16.7 13.9 16.3L17.4 10.8C17.4 10.8 17.4 10.7 17.5 10.7C17.5 10.6 17.6 10.6 17.6 10.5C17.6 10.4 17.7 10.3 17.6 10.1C17.5 10.1 17.5 10 17.4 9.90005Z"
          fill={color ? color: "var(--color-black)"}
        />
      </g>
      <defs>
        <clipPath id="clip0_2728:10140">
          <rect width="17.5" height="19.5" fill={color ? color: "var(--color-black)"} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SalirIconDrop;
